import React, { useEffect } from 'react';
import { Row, Col, Badge } from 'antd';
import CaretUp from '../svg/CaretUp';
import CaretDown from '../svg/CaretDown';
import LineGraph from 'components/shared/graphs/LineGraph';
import ProbabilityStatement from '../ProbabilityStatement';
import PercentageBars from '../PercentageBars';
import RecommendedAction from '../RecommendedAction';
import { renderData } from '../../utils/renderer';
import { getCampaignKey, getCampaignName, renderName } from 'utils/adaya/CampaignUtils';

import utmIcon1 from '../../../../../../static/images/utm_1.svg';
import utmIcon2 from '../../../../../../static/images/utm_2.svg';
import utmIcon3 from '../../../../../../static/images/utm_3.svg';

const gradientColors = {
    y: ['rgba(57, 118, 238, 0.4)', 'rgba(57, 118, 238, 0)']
};

const CampaignsListItem = React.memo(
    ({ mobile, campaign, selectedMetric, summaryValue, statement, probability, action, data, options, color, index, active, showGraph }) => {
        return mobile ? (
            <div className="campaign-mobile campaign-row">
                <div className={`c-wrapper flex column ${color}`}>
                    <div className={`c-name flex align-center`}>
                        <div className={`svg ${color}`}>{color === 'green' ? <CaretUp /> : <CaretDown />}</div>
                        <span className="name">{renderName(getCampaignName(campaign))}</span>
                    </div>

                    <div className="line-container">
                        <div className={'line ' + (showGraph ? 'show-graph' : 'hide-graph')}>
                            {data.length === 7 && active && <LineGraph data={renderData(data)} options={options} gradientColors={gradientColors} active={active} />}
                        </div>
                    </div>

                    <div className="c-data flex space-between align-start">
                        <div className="c-details">
                            <h3>{summaryValue}</h3>
                            <p>{selectedMetric}</p>
                            <p>Last 7 Days</p>
                        </div>

                        <div className="c-statement">
                            <ProbabilityStatement statement={statement} />
                        </div>

                        <div className="c-probability flex column">
                            <PercentageBars mobile={true} statement={statement} probability={probability} />
                            <RecommendedAction data={action} />
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div className="campaign-desktop row campaign-row" key={getCampaignKey(campaign)}>
                <div className={'graph-row col-50 _left flex align-center' + (index % 2 == 0 ? ' left_even' : ' left_odd')}>
                    <Row style={{ width: '100%', height: '100%', alignItems: 'center' }}>
                        <Col span={12} style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                            {index % 3 === 0 && (
                                <div id="utm-1" className="utm-source">
                                    <img src={utmIcon1} style={{ height: 13, width: 18 }} alt="utm1" />
                                </div>
                            )}
                            {index % 3 === 1 && (
                                <div id="utm-2" className="utm-source">
                                    <img src={utmIcon2} style={{ height: 17, width: 19 }} alt="utm2" />
                                </div>
                            )}
                            {index % 3 === 2 && (
                                <div id="utm-3" className="utm-source">
                                    <img src={utmIcon3} style={{ height: 18, width: 15 }} alt="utm3" />
                                </div>
                            )}
                            <div style={{ display: 'flex' }}>
                                {campaign.isActive ? <Badge status="success" /> : <Badge status="default" />}
                                <p>{renderName(getCampaignName(campaign))}</p>
                            </div>
                        </Col>
                        <Col span={3} style={{ textAlign: 'center' }}>
                            <h4>{summaryValue}</h4>
                        </Col>
                        <Col span={9} className="line-container">
                            <div className={'line ' + (showGraph ? 'show-graph' : 'hide-graph')}>
                                {data.length === 7 && active && <LineGraph data={renderData(data)} options={options} gradientColors={gradientColors} active={active} />}
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={'predict-row col-50 _right white flex align-center' + (index % 2 == 0 ? ' right_even' : ' right_odd')}>
                    <Row style={{ width: '100%', height: '100%', alignItems: 'center' }}>
                        <Col span={8}>
                            <ProbabilityStatement statement={statement} />
                        </Col>
                        <Col span={8}>
                            <PercentageBars statement={statement} probability={probability} />
                        </Col>
                        <Col span={8}>
                            <RecommendedAction data={action} />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    },
    (prevProps, nextProps) => {
        if (
            prevProps.mobile === nextProps.mobile &&
            prevProps.campaign == nextProps.campaign &&
            prevProps.campaign_name === nextProps.campaign_name &&
            // prevProps.selectedMetric === nextProps.selectedMetric &&
            prevProps.data === nextProps.data &&
            prevProps.active === nextProps.active &&
            prevProps.showGraph === nextProps.showGraph
        ) {
            return true;
        }

        return false;
    }
);

export default CampaignsListItem;
